/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ partners: NonNullable<unknown>, invoiced: NonNullable<unknown>, paid: NonNullable<unknown>, waived: NonNullable<unknown>, amount: NonNullable<unknown> }} Partner_Billing_Board_Meta_Settled_WaivedInputs */



/**
* | output |
* | --- |
* | "{partners} partners · {invoiced} invoiced, {paid} paid, {waived} waived · {amount}" |
*
* @param {Partner_Billing_Board_Meta_Settled_WaivedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_meta_settled_waived = /** @type {((inputs: Partner_Billing_Board_Meta_Settled_WaivedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Meta_Settled_WaivedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.partners} Partner · ${i?.invoiced} fakturiert, ${i?.paid} bezahlt, ${i?.waived} erlassen · ${i?.amount}`)
	return /** @type {LocalizedString} */ (`${i?.partners} partners · ${i?.invoiced} invoiced, ${i?.paid} paid, ${i?.waived} waived · ${i?.amount}`)
});